export default __webpack_public_path__ + "static/media/warning.912acc0f.svg";